class WS {
  constructor() {
    if (!this.instance) {
      this.instance = {
        connectionUrl: `${import.meta.env.VITE_APP_WS_HOST}`,
      };
    }

    return this;
  }

  connectionUrl() {
    return this.instance.connectionUrl;
  }
}

export default new WS();
